import { forwardRef } from 'react';

import { Link, LinkProps } from '@backstage/core-components';

import { useConfidenceUrl } from '../../hooks';

export const ConfidenceWebsiteLink = forwardRef<
  HTMLAnchorElement,
  Omit<LinkProps, 'to' | 'href'> & { route?: string }
>(({ route = '', target = '_blank', ...props }, ref) => {
  const url = useConfidenceUrl(route);
  return <Link {...props} to={url.href} target={target} ref={ref} />;
});
ConfidenceWebsiteLink.displayName = 'ConfidenceWebsiteLink';
